var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 346.41 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#fff;}.cls-4{fill:#b4cade;}.cls-5{fill:#8ea8bf;}.cls-6{fill:#dce8f2;}.cls-7{fill:#f6f6f6;opacity:.82;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 346.41,
    height: 225
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NewGroup"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "346.41 175 346.41 200 324.76 212.5 303.11 200 303.11 175 324.76 162.5 346.41 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "346.41 195.02 346.41 193.98 329.97 184.49 329.97 165.51 329.07 164.99 329.07 185.01 346.41 195.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "346.41 191.52 346.41 190.48 333 182.74 333 167.26 332.1 166.74 332.1 183.26 346.41 191.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "346.41 188.02 346.41 186.98 336.04 180.99 336.04 169.01 335.14 168.49 335.14 181.51 346.41 188.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "313.48 169.01 313.48 180.99 303.11 186.98 303.11 186.98 303.11 188.02 303.11 188.02 314.38 181.51 314.38 168.49 313.48 169.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "316.52 167.26 316.52 182.74 303.11 190.48 303.11 190.48 303.11 191.52 303.11 191.52 317.42 183.26 317.42 166.74 316.52 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "319.55 165.51 319.55 184.49 303.11 193.98 303.11 193.98 303.11 195.02 303.11 195.02 320.45 185.01 320.45 164.99 319.55 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "308.32 203.01 324.76 193.52 341.2 203.01 341.2 203.01 342.1 202.49 342.1 202.49 324.76 192.48 307.42 202.49 307.42 202.49 308.32 203.01 308.32 203.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "311.35 204.76 324.76 197.02 338.17 204.76 338.17 204.76 339.07 204.24 339.07 204.24 324.76 195.98 310.45 204.24 310.45 204.24 311.35 204.76 311.35 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "314.38 206.51 324.76 200.52 335.14 206.51 335.14 206.51 336.04 205.99 336.04 205.99 324.76 199.48 313.48 205.99 313.48 205.99 314.38 206.51 314.38 206.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "303.11 175 303.11 200 281.46 212.5 259.81 200 259.81 175 281.46 162.5 303.11 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 195.02 303.11 193.98 286.67 184.49 286.67 165.51 285.77 164.99 285.77 185.01 303.11 195.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 191.52 303.11 190.48 289.7 182.74 289.7 167.26 288.8 166.74 288.8 183.26 303.11 191.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 188.02 303.11 186.98 292.73 180.99 292.73 169.01 291.83 168.49 291.83 181.51 303.11 188.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "270.18 169.01 270.18 180.99 259.81 186.98 259.81 186.98 259.81 188.02 259.81 188.02 271.08 181.51 271.08 168.49 270.18 169.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "273.21 167.26 273.21 182.74 259.81 190.48 259.81 190.48 259.81 191.52 259.81 191.52 274.11 183.26 274.11 166.74 273.21 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "276.25 165.51 276.25 184.49 259.81 193.98 259.81 193.98 259.81 195.02 259.81 195.02 277.15 185.01 277.15 164.99 276.25 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "265.02 203.01 281.46 193.52 297.9 203.01 297.9 203.01 298.8 202.49 298.8 202.49 281.46 192.48 264.12 202.49 264.12 202.49 265.02 203.01 265.02 203.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "268.05 204.76 281.46 197.02 294.87 204.76 294.87 204.76 295.76 204.24 295.76 204.24 281.46 195.98 267.15 204.24 267.15 204.24 268.05 204.76 268.05 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "271.08 206.51 281.46 200.52 291.83 206.51 291.83 206.51 292.73 205.99 292.73 205.99 281.46 199.48 270.18 205.99 270.18 205.99 271.08 206.51 271.08 206.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "259.81 175 259.81 200 238.16 212.5 216.51 200 216.51 175 238.16 162.5 259.81 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "259.81 195.02 259.81 193.98 243.37 184.49 243.37 165.51 242.47 164.99 242.47 185.01 259.81 195.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "259.81 191.52 259.81 190.48 246.4 182.74 246.4 167.26 245.5 166.74 245.5 183.26 259.81 191.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "259.81 188.02 259.81 186.98 249.43 180.99 249.43 169.01 248.53 168.49 248.53 181.51 259.81 188.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "226.88 169.01 226.88 180.99 216.51 186.98 216.51 186.98 216.51 188.02 216.51 188.02 227.78 181.51 227.78 168.49 226.88 169.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "229.91 167.26 229.91 182.74 216.51 190.48 216.51 190.48 216.51 191.52 216.51 191.52 230.81 183.26 230.81 166.74 229.91 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "232.94 165.51 232.94 184.49 216.51 193.98 216.51 193.98 216.51 195.02 216.51 195.02 233.84 185.01 233.84 164.99 232.94 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "221.72 203.01 238.16 193.52 254.59 203.01 254.59 203.01 255.49 202.49 255.49 202.49 238.16 192.48 220.82 202.49 220.82 202.49 221.72 203.01 221.72 203.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "224.75 204.76 238.16 197.02 251.56 204.76 251.56 204.76 252.46 204.24 252.46 204.24 238.16 195.98 223.85 204.24 223.85 204.24 224.75 204.76 224.75 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "227.78 206.51 238.16 200.52 248.53 206.51 248.53 206.51 249.43 205.99 249.43 205.99 238.16 199.48 226.88 205.99 226.88 205.99 227.78 206.51 227.78 206.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.51 200 194.86 212.5 173.21 200 173.21 175 194.86 162.5 216.51 175 216.51 200"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.17 210.01 200.07 209.49 200.07 190.51 216.51 181.02 216.51 179.98 199.17 189.99 199.17 210.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.2 208.26 203.1 207.74 203.1 192.26 216.51 184.52 216.51 183.48 202.2 191.74 202.2 208.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.23 206.51 206.13 205.99 206.13 194.01 216.51 188.02 216.51 186.98 205.23 193.49 205.23 206.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "205.23 168.49 194.86 174.48 184.48 168.49 184.48 168.49 183.58 169.01 183.58 169.01 194.86 175.52 206.13 169.01 205.23 168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "208.26 170.24 194.86 177.98 181.45 170.24 181.45 170.24 180.55 170.76 180.55 170.76 194.86 179.02 209.16 170.76 208.26 170.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "211.29 171.99 194.86 181.48 178.42 171.99 178.42 171.99 177.52 172.51 177.52 172.51 194.86 182.52 212.19 172.51 211.29 171.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.21 181.02 189.64 190.51 189.64 209.49 189.64 209.49 190.54 210.01 190.54 210.01 190.54 189.99 173.21 179.98 173.21 179.98 173.21 181.02 173.21 181.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.21 184.52 186.61 192.26 186.61 207.74 186.61 207.74 187.51 208.26 187.51 208.26 187.51 191.74 173.21 183.48 173.21 183.48 173.21 184.52 173.21 184.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.21 188.02 183.58 194.01 183.58 205.99 183.58 205.99 184.48 206.51 184.48 206.51 184.48 193.49 173.21 186.98 173.21 186.98 173.21 188.02 173.21 188.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.21 200 151.55 212.5 129.9 200 129.9 175 151.55 162.5 173.21 175 173.21 200"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "155.87 210.01 156.77 209.49 156.77 190.51 173.21 181.02 173.21 179.98 155.87 189.99 155.87 210.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "158.9 208.26 159.8 207.74 159.8 192.26 173.21 184.52 173.21 183.48 158.9 191.74 158.9 208.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.93 206.51 162.83 205.99 162.83 194.01 173.21 188.02 173.21 186.98 161.93 193.49 161.93 206.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.93 168.49 151.55 174.48 141.18 168.49 141.18 168.49 140.28 169.01 140.28 169.01 151.55 175.52 162.83 169.01 161.93 168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.96 170.24 151.55 177.98 138.15 170.24 138.15 170.24 137.25 170.76 137.25 170.76 151.55 179.02 165.86 170.76 164.96 170.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "167.99 171.99 151.55 181.48 135.12 171.99 135.12 171.99 134.22 172.51 134.22 172.51 151.55 182.52 168.89 172.51 167.99 171.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 181.02 146.34 190.51 146.34 209.49 146.34 209.49 147.24 210.01 147.24 210.01 147.24 189.99 129.9 179.98 129.9 179.98 129.9 181.02 129.9 181.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 184.52 143.31 192.26 143.31 207.74 143.31 207.74 144.21 208.26 144.21 208.26 144.21 191.74 129.9 183.48 129.9 183.48 129.9 184.52 129.9 184.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 188.02 140.28 194.01 140.28 205.99 140.28 205.99 141.18 206.51 141.18 206.51 141.18 193.49 129.9 186.98 129.9 186.98 129.9 188.02 129.9 188.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.9 175 129.9 200 108.25 212.5 86.6 200 86.6 175 108.25 162.5 129.9 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "129.9 195.02 129.9 193.98 113.47 184.49 113.47 165.51 112.57 164.99 112.57 185.01 129.9 195.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "129.9 191.52 129.9 190.48 116.5 182.74 116.5 167.26 115.6 166.74 115.6 183.26 129.9 191.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "129.9 188.02 129.9 186.98 119.53 180.99 119.53 169.01 118.63 168.49 118.63 181.51 129.9 188.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "96.98 169.01 96.98 180.99 86.6 186.98 86.6 186.98 86.6 188.02 86.6 188.02 97.88 181.51 97.88 168.49 96.98 169.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "100.01 167.26 100.01 182.74 86.6 190.48 86.6 190.48 86.6 191.52 86.6 191.52 100.91 183.26 100.91 166.74 100.01 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "103.04 165.51 103.04 184.49 86.6 193.98 86.6 193.98 86.6 195.02 86.6 195.02 103.94 185.01 103.94 164.99 103.04 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "91.82 203.01 108.25 193.52 124.69 203.01 124.69 203.01 125.59 202.49 125.59 202.49 108.25 192.48 90.92 202.49 90.92 202.49 91.82 203.01 91.82 203.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "94.85 204.76 108.25 197.02 121.66 204.76 121.66 204.76 122.56 204.24 122.56 204.24 108.25 195.98 93.95 204.24 93.95 204.24 94.85 204.76 94.85 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "97.88 206.51 108.25 200.52 118.63 206.51 118.63 206.51 119.53 205.99 119.53 205.99 108.25 199.48 96.98 205.99 96.98 205.99 97.88 206.51 97.88 206.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.95 212.5 43.3 200 43.3 175 64.95 162.5 86.6 175 86.6 200 64.95 212.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "47.61 202.49 48.51 203.01 64.95 193.52 81.39 203.01 82.29 202.49 64.95 192.48 47.61 202.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "50.65 204.24 51.55 204.76 64.95 197.02 78.36 204.76 79.26 204.24 64.95 195.98 50.65 204.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "53.68 205.99 54.58 206.51 64.95 200.52 75.33 206.51 76.23 205.99 64.95 199.48 53.68 205.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.6 186.98 76.23 180.99 76.23 169.01 76.23 169.01 75.33 168.49 75.33 168.49 75.33 181.51 86.6 188.02 86.6 186.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.6 190.48 73.2 182.74 73.2 167.26 73.2 167.26 72.3 166.74 72.3 166.74 72.3 183.26 86.6 191.52 86.6 190.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.6 193.98 70.17 184.49 70.17 165.51 70.17 165.51 69.27 164.99 69.26 164.99 69.26 185.01 86.6 195.02 86.6 193.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "59.74 165.51 59.74 184.49 43.3 193.98 43.3 193.98 43.3 195.02 43.3 195.02 60.64 185.01 60.64 164.99 60.64 164.99 59.74 165.51 59.74 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "56.71 167.26 56.71 182.74 43.3 190.48 43.3 190.48 43.3 191.52 43.3 191.52 57.61 183.26 57.61 166.74 57.61 166.74 56.71 167.26 56.71 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "53.68 169.01 53.68 180.99 43.3 186.98 43.3 186.98 43.3 188.02 43.3 188.02 54.58 181.51 54.58 168.49 54.58 168.49 53.68 169.01 53.68 169.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.3 200 21.65 212.5 0 200 0 175 21.65 162.5 43.3 175 43.3 200"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "25.96 210.01 26.86 209.49 26.86 190.51 43.3 181.02 43.3 179.98 25.96 189.99 25.96 210.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.99 208.26 29.9 207.74 29.89 192.26 43.3 184.52 43.3 183.48 29 191.74 28.99 208.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "32.03 206.51 32.93 205.99 32.93 194.01 43.3 188.02 43.3 186.98 32.03 193.49 32.03 206.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "32.03 168.49 21.65 174.48 11.28 168.49 11.28 168.49 10.38 169.01 10.38 169.01 21.65 175.52 32.93 169.01 32.03 168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.06 170.24 21.65 177.98 8.24 170.24 8.24 170.24 7.34 170.76 7.34 170.76 21.65 179.02 35.96 170.76 35.06 170.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "38.09 171.99 21.65 181.48 5.21 171.99 5.21 171.99 4.31 172.51 4.31 172.51 21.65 182.52 38.99 172.51 38.09 171.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 181.02 16.44 190.51 16.44 209.49 16.44 209.49 17.34 210.01 17.34 210.01 17.34 189.99 0 179.98 0 179.98 0 181.02 0 181.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 184.52 13.41 192.26 13.41 207.74 13.41 207.74 14.31 208.26 14.31 208.26 14.31 191.74 0 183.48 0 183.48 0 184.52 0 184.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 188.02 10.38 194.01 10.38 205.99 10.38 205.99 11.28 206.51 11.28 206.51 11.28 193.49 0 186.98 0 186.98 0 188.02 0 188.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "324.76 162.5 303.11 175 281.46 162.5 281.46 137.5 303.11 125 324.76 137.5 324.76 162.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "307.42 172.51 308.32 171.99 308.32 153.01 324.76 143.52 324.76 142.48 307.42 152.49 307.42 172.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "310.45 170.76 311.35 170.24 311.35 154.76 324.76 147.02 324.76 145.98 310.45 154.24 310.45 170.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.48 169.01 314.38 168.49 314.38 156.51 324.76 150.52 324.76 149.48 313.48 155.99 313.48 169.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "313.48 130.99 303.11 136.98 292.73 130.99 292.73 130.99 291.83 131.51 291.83 131.51 303.11 138.02 314.38 131.51 313.48 130.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "316.52 132.74 303.11 140.48 289.7 132.74 289.7 132.74 288.8 133.26 288.8 133.26 303.11 141.52 317.42 133.26 316.52 132.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "319.55 134.49 303.11 143.98 286.67 134.49 286.67 134.49 285.77 135.01 285.77 135.01 303.11 145.02 320.45 135.01 319.55 134.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 143.52 297.9 153.01 297.9 171.99 297.9 171.99 298.8 172.51 298.8 172.51 298.8 152.49 281.46 142.48 281.46 142.48 281.46 143.52 281.46 143.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 147.02 294.87 154.76 294.87 170.24 294.87 170.24 295.76 170.76 295.77 170.76 295.77 154.24 281.46 145.98 281.46 145.98 281.46 147.02 281.46 147.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 150.52 291.83 156.51 291.83 168.49 291.83 168.49 292.73 169.01 292.73 169.01 292.73 155.99 281.46 149.48 281.46 149.48 281.46 150.52 281.46 150.52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "259.81 175 238.16 162.5 238.16 137.5 259.81 125 281.46 137.5 281.46 162.5 259.81 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.47 164.99 243.37 165.51 259.81 156.02 276.25 165.51 277.15 164.99 259.81 154.98 242.47 164.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "245.5 166.74 246.4 167.26 259.81 159.52 273.21 167.26 274.11 166.74 259.81 158.48 245.5 166.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "248.53 168.49 249.43 169.01 259.81 163.02 270.18 169.01 271.08 168.49 259.81 161.98 248.53 168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "281.46 149.48 271.08 143.49 271.08 131.51 271.08 131.51 270.18 130.99 270.18 130.99 270.18 144.01 281.46 150.52 281.46 149.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "281.46 152.98 268.05 145.24 268.05 129.76 268.05 129.76 267.15 129.24 267.15 129.24 267.15 145.76 281.46 154.02 281.46 152.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "281.46 156.48 265.02 146.99 265.02 128.01 265.02 128.01 264.12 127.49 264.12 127.49 264.12 147.51 281.46 157.52 281.46 156.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "254.59 128.01 254.59 146.99 238.16 156.48 238.16 156.48 238.16 157.52 238.16 157.52 255.5 147.51 255.5 127.49 255.49 127.49 254.59 128.01 254.59 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "251.56 129.76 251.56 145.24 238.16 152.98 238.16 152.98 238.16 154.02 238.16 154.02 252.46 145.76 252.46 129.24 252.46 129.24 251.56 129.76 251.56 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "248.53 131.51 248.53 143.49 238.16 149.48 238.16 149.48 238.16 150.52 238.16 150.52 249.43 144.01 249.43 130.99 249.43 130.99 248.53 131.51 248.53 131.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.51 175 194.86 162.5 194.86 137.5 216.51 125 238.16 137.5 238.16 162.5 216.51 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.17 164.99 200.07 165.51 216.51 156.02 232.94 165.51 233.84 164.99 216.51 154.98 199.17 164.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.2 166.74 203.1 167.26 216.51 159.52 229.91 167.26 230.81 166.74 216.51 158.48 202.2 166.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.23 168.49 206.13 169.01 216.51 163.02 226.88 169.01 227.78 168.49 216.51 161.98 205.23 168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "238.16 149.48 227.78 143.49 227.78 131.51 227.78 131.51 226.88 130.99 226.88 130.99 226.88 144.01 238.16 150.52 238.16 149.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "238.16 152.98 224.75 145.24 224.75 129.76 224.75 129.76 223.85 129.24 223.85 129.24 223.85 145.76 238.16 154.02 238.16 152.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "238.16 156.48 221.72 146.99 221.72 128.01 221.72 128.01 220.82 127.49 220.82 127.49 220.82 147.51 238.16 157.52 238.16 156.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "211.29 128.01 211.29 146.99 194.86 156.48 194.86 156.48 194.86 157.52 194.86 157.52 212.19 147.51 212.19 127.49 212.19 127.49 211.29 128.01 211.29 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "208.26 129.76 208.26 145.24 194.86 152.98 194.86 152.98 194.86 154.02 194.86 154.02 209.16 145.76 209.16 129.24 209.16 129.24 208.26 129.76 208.26 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "205.23 131.51 205.23 143.49 194.86 149.48 194.86 149.48 194.86 150.52 194.86 150.52 206.13 144.01 206.13 130.99 206.13 130.99 205.23 131.51 205.23 131.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "194.86 137.5 194.86 162.5 173.21 175 151.55 162.5 151.55 137.5 173.21 125 194.86 137.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 157.52 194.86 156.48 178.42 146.99 178.42 128.01 177.52 127.49 177.52 147.51 194.86 157.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 154.02 194.86 152.98 181.45 145.24 181.45 129.76 180.55 129.24 180.55 145.76 194.86 154.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 150.52 194.86 149.48 184.48 143.49 184.48 131.51 183.58 130.99 183.58 144.01 194.86 150.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.93 131.51 161.93 143.49 151.55 149.48 151.55 149.48 151.55 150.52 151.56 150.52 162.83 144.01 162.83 130.99 161.93 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.96 129.76 164.96 145.24 151.55 152.98 151.55 152.98 151.55 154.02 151.55 154.02 165.86 145.76 165.86 129.24 164.96 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "167.99 128.01 167.99 146.99 151.55 156.48 151.55 156.48 151.55 157.52 151.56 157.52 168.89 147.51 168.89 127.49 167.99 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "156.77 165.51 173.21 156.02 189.64 165.51 189.64 165.51 190.54 164.99 190.54 164.99 173.21 154.98 155.87 164.99 155.87 164.99 156.77 165.51 156.77 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "159.8 167.26 173.21 159.52 186.61 167.26 186.61 167.26 187.51 166.74 187.51 166.74 173.21 158.48 158.9 166.74 158.9 166.74 159.8 167.26 159.8 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "162.83 169.01 173.21 163.02 183.58 169.01 183.58 169.01 184.48 168.49 184.48 168.49 173.21 161.98 161.93 168.49 161.93 168.49 162.83 169.01 162.83 169.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "151.55 162.5 129.9 175 108.25 162.5 108.25 137.5 129.9 125 151.55 137.5 151.55 162.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "134.22 172.51 135.12 171.99 135.12 153.01 151.55 143.52 151.55 142.48 134.22 152.49 134.22 172.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "137.25 170.76 138.15 170.24 138.15 154.76 151.55 147.02 151.55 145.98 137.25 154.24 137.25 170.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "140.28 169.01 141.18 168.49 141.18 156.51 151.55 150.52 151.55 149.48 140.28 155.99 140.28 169.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "140.28 130.99 129.9 136.98 119.53 130.99 119.53 130.99 118.63 131.51 118.63 131.51 129.9 138.02 141.18 131.51 140.28 130.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "143.31 132.74 129.9 140.48 116.5 132.74 116.5 132.74 115.6 133.26 115.6 133.26 129.9 141.52 144.21 133.26 143.31 132.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "146.34 134.49 129.9 143.98 113.47 134.49 113.47 134.49 112.57 135.01 112.57 135.01 129.9 145.02 147.24 135.01 146.34 134.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.25 143.52 124.69 153.01 124.69 171.99 124.69 171.99 125.59 172.51 125.59 172.51 125.59 152.49 108.25 142.48 108.25 142.48 108.25 143.52 108.25 143.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.25 147.02 121.66 154.76 121.66 170.24 121.66 170.24 122.56 170.76 122.56 170.76 122.56 154.24 108.25 145.98 108.25 145.98 108.25 147.02 108.25 147.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.25 150.52 118.63 156.51 118.63 168.49 118.63 168.49 119.53 169.01 119.53 169.01 119.53 155.99 108.25 149.48 108.25 149.48 108.25 150.52 108.25 150.52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.6 175 64.95 162.5 64.95 137.5 86.6 125 108.25 137.5 108.25 162.5 86.6 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "69.27 164.99 70.17 165.51 86.6 156.02 103.04 165.51 103.94 164.99 86.6 154.98 69.27 164.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "72.3 166.74 73.2 167.26 86.6 159.52 100.01 167.26 100.91 166.74 86.6 158.48 72.3 166.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "75.33 168.49 76.23 169.01 86.6 163.02 96.98 169.01 97.88 168.49 86.6 161.98 75.33 168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 149.48 97.88 143.49 97.88 131.51 97.88 131.51 96.98 130.99 96.98 130.99 96.98 144.01 108.25 150.52 108.25 149.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 152.98 94.85 145.24 94.85 129.76 94.85 129.76 93.95 129.24 93.95 129.24 93.95 145.76 108.25 154.02 108.25 152.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 156.48 91.82 146.99 91.82 128.01 91.82 128.01 90.92 127.49 90.92 127.49 90.92 147.51 108.25 157.52 108.25 156.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "81.39 128.01 81.39 146.99 64.95 156.48 64.95 156.48 64.95 157.52 64.95 157.52 82.29 147.51 82.29 127.49 82.29 127.49 81.39 128.01 81.39 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.36 129.76 78.36 145.24 64.95 152.98 64.95 152.98 64.95 154.02 64.95 154.02 79.26 145.76 79.26 129.24 79.26 129.24 78.36 129.76 78.36 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "75.33 131.51 75.33 143.49 64.95 149.48 64.95 149.48 64.95 150.52 64.95 150.52 76.23 144.01 76.23 130.99 76.23 130.99 75.33 131.51 75.33 131.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.3 175 21.65 162.5 21.65 137.5 43.3 125 64.95 137.5 64.95 162.5 43.3 175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "25.96 164.99 26.86 165.51 43.3 156.02 59.74 165.51 60.64 164.99 43.3 154.98 25.96 164.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.99 166.74 29.9 167.26 43.3 159.52 56.71 167.26 57.61 166.74 43.3 158.48 28.99 166.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "32.03 168.49 32.93 169.01 43.3 163.02 53.68 169.01 54.58 168.49 43.3 161.98 32.03 168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 149.48 54.58 143.49 54.58 131.51 54.58 131.51 53.68 130.99 53.68 130.99 53.68 144.01 64.95 150.52 64.95 149.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 152.98 51.55 145.24 51.55 129.76 51.55 129.76 50.65 129.24 50.65 129.24 50.65 145.76 64.95 154.02 64.95 152.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 156.48 48.51 146.99 48.51 128.01 48.51 128.01 47.61 127.49 47.61 127.49 47.61 147.51 64.95 157.52 64.95 156.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "38.09 128.01 38.09 146.99 21.65 156.48 21.65 156.48 21.65 157.52 21.65 157.52 38.99 147.51 38.99 127.49 38.99 127.49 38.09 128.01 38.09 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.06 129.76 35.06 145.24 21.65 152.98 21.65 152.98 21.65 154.02 21.65 154.02 35.96 145.76 35.96 129.24 35.96 129.24 35.06 129.76 35.06 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "32.03 131.51 32.03 143.49 21.65 149.48 21.65 149.48 21.65 150.52 21.65 150.52 32.93 144.01 32.93 130.99 32.93 130.99 32.03 131.51 32.03 131.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "368.06 137.5 368.06 162.5 346.41 175 324.76 162.5 324.76 137.5 346.41 125 368.06 137.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "335.14 131.51 335.14 143.49 324.76 149.48 324.76 149.48 324.76 150.52 324.76 150.52 336.04 144.01 336.04 130.99 335.14 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "338.17 129.76 338.17 145.24 324.76 152.98 324.76 152.98 324.76 154.02 324.76 154.02 339.07 145.76 339.07 129.24 338.17 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "341.2 128.01 341.2 146.99 324.76 156.48 324.76 156.48 324.76 157.52 324.76 157.52 342.1 147.51 342.1 127.49 341.2 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "329.97 165.51 346.41 156.02 362.85 165.51 362.85 165.51 363.75 164.99 363.75 164.99 346.41 154.98 329.07 164.99 329.07 164.99 329.97 165.51 329.97 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "333 167.26 346.41 159.52 359.82 167.26 359.82 167.26 360.72 166.74 360.72 166.74 346.41 158.48 332.1 166.74 332.1 166.74 333 167.26 333 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "336.04 169.01 346.41 163.02 356.79 169.01 356.79 169.01 357.69 168.49 357.69 168.49 346.41 161.98 335.14 168.49 335.14 168.49 336.04 169.01 336.04 169.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.65 137.5 21.65 162.5 0 175 -21.65 162.5 -21.65 137.5 0 125 21.65 137.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "21.65 157.52 21.65 156.48 5.21 146.99 5.21 128.01 4.31 127.49 4.31 147.51 21.65 157.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "21.65 154.02 21.65 152.98 8.24 145.24 8.24 129.76 7.34 129.24 7.34 145.76 21.65 154.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "21.65 150.52 21.65 149.48 11.28 143.49 11.28 131.51 10.38 130.99 10.38 144.01 21.65 150.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-16.44 165.51 0 156.02 16.44 165.51 16.44 165.51 17.34 164.99 17.34 164.99 0 154.98 -17.34 164.99 -17.34 164.99 -16.44 165.51 -16.44 165.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-13.41 167.26 0 159.52 13.41 167.26 13.41 167.26 14.31 166.74 14.31 166.74 0 158.48 -14.31 166.74 -14.31 166.74 -13.41 167.26 -13.41 167.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-10.38 169.01 0 163.02 10.38 169.01 10.38 169.01 11.28 168.49 11.28 168.49 0 161.98 -11.28 168.49 -11.28 168.49 -10.38 169.01 -10.38 169.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "346.41 125 324.76 137.5 303.11 125 303.11 100 324.76 87.5 346.41 100 346.41 125"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "329.07 135.01 329.97 134.49 329.97 115.51 346.41 106.02 346.41 104.98 329.07 114.99 329.07 135.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "332.1 133.26 333 132.74 333 117.26 346.41 109.52 346.41 108.48 332.1 116.74 332.1 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "335.14 131.51 336.04 130.99 336.04 119.01 346.41 113.02 346.41 111.98 335.14 118.49 335.14 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "335.14 93.49 324.76 99.48 314.38 93.49 314.38 93.49 313.48 94.01 313.48 94.01 324.76 100.52 336.04 94.01 335.14 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "338.17 95.24 324.76 102.98 311.35 95.24 311.35 95.24 310.45 95.76 310.45 95.76 324.76 104.02 339.07 95.76 338.17 95.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "341.2 96.99 324.76 106.48 308.32 96.99 308.32 96.99 307.42 97.51 307.42 97.51 324.76 107.52 342.1 97.51 341.2 96.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "303.11 106.02 319.55 115.51 319.55 134.49 319.55 134.49 320.45 135.01 320.45 135.01 320.45 114.99 303.11 104.98 303.11 104.98 303.11 106.02 303.11 106.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "303.11 109.52 316.52 117.26 316.52 132.74 316.52 132.74 317.42 133.26 317.42 133.26 317.42 116.74 303.11 108.48 303.11 108.48 303.11 109.52 303.11 109.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "303.11 113.02 313.48 119.01 313.48 130.99 313.48 130.99 314.38 131.51 314.38 131.51 314.38 118.49 303.11 111.98 303.11 111.98 303.11 113.02 303.11 113.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "303.11 100 303.11 125 281.46 137.5 259.81 125 259.81 100 281.46 87.5 303.11 100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 120.02 303.11 118.98 286.67 109.49 286.67 90.51 285.77 89.99 285.77 110.01 303.11 120.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 116.52 303.11 115.48 289.7 107.74 289.7 92.26 288.8 91.74 288.8 108.26 303.11 116.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 113.02 303.11 111.98 292.73 105.99 292.73 94.01 291.83 93.49 291.83 106.51 303.11 113.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "270.18 94.01 270.18 105.99 259.81 111.98 259.81 111.98 259.81 113.02 259.81 113.02 271.08 106.51 271.08 93.49 270.18 94.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "273.21 92.26 273.21 107.74 259.81 115.48 259.81 115.48 259.81 116.52 259.81 116.52 274.11 108.26 274.11 91.74 273.21 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "276.25 90.51 276.25 109.49 259.81 118.98 259.81 118.98 259.81 120.02 259.81 120.02 277.15 110.01 277.15 89.99 276.25 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "265.02 128.01 281.46 118.52 297.9 128.01 297.9 128.01 298.8 127.49 298.8 127.49 281.46 117.48 264.12 127.49 264.12 127.49 265.02 128.01 265.02 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "268.05 129.76 281.46 122.02 294.87 129.76 294.87 129.76 295.76 129.24 295.76 129.24 281.46 120.98 267.15 129.24 267.15 129.24 268.05 129.76 268.05 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "271.08 131.51 281.46 125.52 291.83 131.51 291.83 131.51 292.73 130.99 292.73 130.99 281.46 124.48 270.18 130.99 270.18 130.99 271.08 131.51 271.08 131.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "259.81 125 238.16 137.5 216.51 125 216.51 100 238.16 87.5 259.81 100 259.81 125"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.47 135.01 243.37 134.49 243.37 115.51 259.81 106.02 259.81 104.98 242.47 114.99 242.47 135.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "245.5 133.26 246.4 132.74 246.4 117.26 259.81 109.52 259.81 108.48 245.5 116.74 245.5 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "248.53 131.51 249.43 130.99 249.43 119.01 259.81 113.02 259.81 111.98 248.53 118.49 248.53 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "248.53 93.49 238.16 99.48 227.78 93.49 227.78 93.49 226.88 94.01 226.88 94.01 238.16 100.52 249.43 94.01 248.53 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "251.56 95.24 238.16 102.98 224.75 95.24 224.75 95.24 223.85 95.76 223.85 95.76 238.16 104.02 252.46 95.76 251.56 95.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "254.59 96.99 238.16 106.48 221.72 96.99 221.72 96.99 220.82 97.51 220.82 97.51 238.16 107.52 255.49 97.51 254.59 96.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "216.51 106.02 232.94 115.51 232.94 134.49 232.94 134.49 233.84 135.01 233.84 135.01 233.84 114.99 216.51 104.98 216.51 104.98 216.51 106.02 216.51 106.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "216.51 109.52 229.91 117.26 229.91 132.74 229.91 132.74 230.81 133.26 230.81 133.26 230.81 116.74 216.51 108.48 216.51 108.48 216.51 109.52 216.51 109.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "216.51 113.02 226.88 119.01 226.88 130.99 226.88 130.99 227.78 131.51 227.78 131.51 227.78 118.49 216.51 111.98 216.51 111.98 216.51 113.02 216.51 113.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.51 125 194.86 137.5 173.21 125 173.21 100 194.86 87.5 216.51 100 216.51 125"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.17 135.01 200.07 134.49 200.07 115.51 216.51 106.02 216.51 104.98 199.17 114.99 199.17 135.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.2 133.26 203.1 132.74 203.1 117.26 216.51 109.52 216.51 108.48 202.2 116.74 202.2 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.23 131.51 206.13 130.99 206.13 119.01 216.51 113.02 216.51 111.98 205.23 118.49 205.23 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "205.23 93.49 194.86 99.48 184.48 93.49 184.48 93.49 183.58 94.01 183.58 94.01 194.86 100.52 206.13 94.01 205.23 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "208.26 95.24 194.86 102.98 181.45 95.24 181.45 95.24 180.55 95.76 180.55 95.76 194.86 104.02 209.16 95.76 208.26 95.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "211.29 96.99 194.86 106.48 178.42 96.99 178.42 96.99 177.52 97.51 177.52 97.51 194.86 107.52 212.19 97.51 211.29 96.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.21 106.02 189.64 115.51 189.64 134.49 189.64 134.49 190.54 135.01 190.54 135.01 190.54 114.99 173.21 104.98 173.21 104.98 173.21 106.02 173.21 106.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.21 109.52 186.61 117.26 186.61 132.74 186.61 132.74 187.51 133.26 187.51 133.26 187.51 116.74 173.21 108.48 173.21 108.48 173.21 109.52 173.21 109.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "173.21 113.02 183.58 119.01 183.58 130.99 183.58 130.99 184.48 131.51 184.48 131.51 184.48 118.49 173.21 111.98 173.21 111.98 173.21 113.02 173.21 113.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.21 125 151.55 137.5 129.9 125 129.9 100 151.55 87.5 173.21 100 173.21 125"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "155.87 135.01 156.77 134.49 156.77 115.51 173.21 106.02 173.21 104.98 155.87 114.99 155.87 135.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "158.9 133.26 159.8 132.74 159.8 117.26 173.21 109.52 173.21 108.48 158.9 116.74 158.9 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.93 131.51 162.83 130.99 162.83 119.01 173.21 113.02 173.21 111.98 161.93 118.49 161.93 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.93 93.49 151.55 99.48 141.18 93.49 141.18 93.49 140.28 94.01 140.28 94.01 151.55 100.52 162.83 94.01 161.93 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.96 95.24 151.55 102.98 138.15 95.24 138.15 95.24 137.25 95.76 137.25 95.76 151.55 104.02 165.86 95.76 164.96 95.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "167.99 96.99 151.55 106.48 135.12 96.99 135.12 96.99 134.22 97.51 134.22 97.51 151.55 107.52 168.89 97.51 167.99 96.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 106.02 146.34 115.51 146.34 134.49 146.34 134.49 147.24 135.01 147.24 135.01 147.24 114.99 129.9 104.98 129.9 104.98 129.9 106.02 129.9 106.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 109.52 143.31 117.26 143.31 132.74 143.31 132.74 144.21 133.26 144.21 133.26 144.21 116.74 129.9 108.48 129.9 108.48 129.9 109.52 129.9 109.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 113.02 140.28 119.01 140.28 130.99 140.28 130.99 141.18 131.51 141.18 131.51 141.18 118.49 129.9 111.98 129.9 111.98 129.9 113.02 129.9 113.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "129.9 125 108.25 137.5 86.6 125 86.6 100 108.25 87.5 129.9 100 129.9 125"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112.57 135.01 113.47 134.49 113.47 115.51 129.9 106.02 129.9 104.98 112.57 114.99 112.57 135.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "115.6 133.26 116.5 132.74 116.5 117.26 129.9 109.52 129.9 108.48 115.6 116.74 115.6 133.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "118.63 131.51 119.53 130.99 119.53 119.01 129.9 113.02 129.9 111.98 118.63 118.49 118.63 131.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "118.63 93.49 108.25 99.48 97.88 93.49 97.88 93.49 96.98 94.01 96.98 94.01 108.25 100.52 119.53 94.01 118.63 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "121.66 95.24 108.25 102.98 94.85 95.24 94.85 95.24 93.95 95.76 93.95 95.76 108.25 104.02 122.56 95.76 121.66 95.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.69 96.99 108.25 106.48 91.82 96.99 91.82 96.99 90.92 97.51 90.92 97.51 108.25 107.52 125.59 97.51 124.69 96.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "86.6 106.02 103.04 115.51 103.04 134.49 103.04 134.49 103.94 135.01 103.94 135.01 103.94 114.99 86.6 104.98 86.6 104.98 86.6 106.02 86.6 106.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "86.6 109.52 100.01 117.26 100.01 132.74 100.01 132.74 100.91 133.26 100.91 133.26 100.91 116.74 86.6 108.48 86.6 108.48 86.6 109.52 86.6 109.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "86.6 113.02 96.98 119.01 96.98 130.99 96.98 130.99 97.88 131.51 97.88 131.51 97.88 118.49 86.6 111.98 86.6 111.98 86.6 113.02 86.6 113.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.95 137.5 43.3 125 43.3 100 64.95 87.5 86.6 100 86.6 125 64.95 137.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "47.61 127.49 48.51 128.01 64.95 118.52 81.39 128.01 82.29 127.49 64.95 117.48 47.61 127.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "50.65 129.24 51.55 129.76 64.95 122.02 78.36 129.76 79.26 129.24 64.95 120.98 50.65 129.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "53.68 130.99 54.58 131.51 64.95 125.52 75.33 131.51 76.23 130.99 64.95 124.48 53.68 130.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.6 111.98 76.23 105.99 76.23 94.01 76.23 94.01 75.33 93.49 75.33 93.49 75.33 106.51 86.6 113.02 86.6 111.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.6 115.48 73.2 107.74 73.2 92.26 73.2 92.26 72.3 91.74 72.3 91.74 72.3 108.26 86.6 116.52 86.6 115.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.6 118.98 70.17 109.49 70.17 90.51 70.17 90.51 69.27 89.99 69.26 89.99 69.26 110.01 86.6 120.02 86.6 118.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "59.74 90.51 59.74 109.49 43.3 118.98 43.3 118.98 43.3 120.02 43.3 120.02 60.64 110.01 60.64 89.99 60.64 89.99 59.74 90.51 59.74 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "56.71 92.26 56.71 107.74 43.3 115.48 43.3 115.48 43.3 116.52 43.3 116.52 57.61 108.26 57.61 91.74 57.61 91.74 56.71 92.26 56.71 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "53.68 94.01 53.68 105.99 43.3 111.98 43.3 111.98 43.3 113.02 43.3 113.02 54.58 106.51 54.58 93.49 54.58 93.49 53.68 94.01 53.68 94.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.3 100 43.3 125 21.65 137.5 0 125 0 100 21.65 87.5 43.3 100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "43.3 120.02 43.3 118.98 26.86 109.49 26.86 90.51 25.96 89.99 25.96 110.01 43.3 120.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "43.3 116.52 43.3 115.48 29.9 107.74 29.9 92.26 29 91.74 29 108.26 43.3 116.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "43.3 113.02 43.3 111.98 32.93 105.99 32.93 94.01 32.03 93.49 32.03 106.51 43.3 113.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.38 94.01 10.38 105.99 0 111.98 0 111.98 0 113.02 0 113.02 11.28 106.51 11.28 93.49 10.38 94.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "13.41 92.26 13.41 107.74 0 115.48 0 115.48 0 116.52 0 116.52 14.31 108.26 14.31 91.74 13.41 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "16.44 90.51 16.44 109.49 0 118.98 0 118.98 0 120.02 0 120.02 17.34 110.01 17.34 89.99 16.44 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5.21 128.01 21.65 118.52 38.09 128.01 38.09 128.01 38.99 127.49 38.99 127.49 21.65 117.48 4.31 127.49 4.31 127.49 5.21 128.01 5.21 128.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "8.24 129.76 21.65 122.02 35.06 129.76 35.06 129.76 35.96 129.24 35.96 129.24 21.65 120.98 7.34 129.24 7.34 129.24 8.24 129.76 8.24 129.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "11.28 131.51 21.65 125.52 32.03 131.51 32.03 131.51 32.93 130.99 32.93 130.99 21.65 124.48 10.38 130.99 10.38 130.99 11.28 131.51 11.28 131.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "303.11 100 281.46 87.5 281.46 62.5 303.11 50 324.76 62.5 324.76 87.5 303.11 100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "285.77 89.99 286.67 90.51 303.11 81.02 319.55 90.51 320.45 89.99 303.11 79.98 285.77 89.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "288.8 91.74 289.7 92.26 303.11 84.52 316.52 92.26 317.42 91.74 303.11 83.48 288.8 91.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "291.83 93.49 292.73 94.01 303.11 88.02 313.48 94.01 314.38 93.49 303.11 86.98 291.83 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "324.76 74.48 314.38 68.49 314.38 56.51 314.38 56.51 313.48 55.99 313.48 55.99 313.48 69.01 324.76 75.52 324.76 74.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "324.76 77.98 311.35 70.24 311.35 54.76 311.35 54.76 310.45 54.24 310.45 54.24 310.45 70.76 324.76 79.02 324.76 77.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "324.76 81.48 308.32 71.99 308.32 53.01 308.32 53.01 307.42 52.49 307.42 52.49 307.42 72.51 324.76 82.52 324.76 81.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "297.9 53.01 297.9 71.99 281.46 81.48 281.46 81.48 281.46 82.52 281.46 82.52 298.8 72.51 298.8 52.49 298.8 52.49 297.9 53.01 297.9 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.86 54.76 294.86 70.24 281.46 77.98 281.46 77.98 281.46 79.02 281.46 79.02 295.77 70.76 295.77 54.24 295.76 54.24 294.86 54.76 294.86 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "291.83 56.51 291.83 68.49 281.46 74.48 281.46 74.48 281.46 75.52 281.46 75.52 292.73 69.01 292.73 55.99 292.73 55.99 291.83 56.51 291.83 56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "281.46 62.5 281.46 87.5 259.81 100 238.16 87.5 238.16 62.5 259.81 50 281.46 62.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 82.52 281.46 81.48 265.02 71.99 265.02 53.01 264.12 52.49 264.12 72.51 281.46 82.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 79.02 281.46 77.98 268.05 70.24 268.05 54.76 267.15 54.24 267.15 70.76 281.46 79.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 75.52 281.46 74.48 271.08 68.49 271.08 56.51 270.18 55.99 270.18 69.01 281.46 75.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "248.53 56.51 248.53 68.49 238.16 74.48 238.16 74.48 238.16 75.52 238.16 75.52 249.43 69.01 249.43 55.99 248.53 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "251.56 54.76 251.56 70.24 238.16 77.98 238.16 77.98 238.16 79.02 238.16 79.02 252.46 70.76 252.46 54.24 251.56 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "254.59 53.01 254.59 71.99 238.16 81.48 238.16 81.48 238.16 82.52 238.16 82.52 255.49 72.51 255.49 52.49 254.59 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "243.37 90.51 259.81 81.02 276.25 90.51 276.25 90.51 277.15 89.99 277.15 89.99 259.81 79.98 242.47 89.99 242.47 89.99 243.37 90.51 243.37 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "246.4 92.26 259.81 84.52 273.21 92.26 273.21 92.26 274.11 91.74 274.11 91.74 259.81 83.48 245.5 91.74 245.5 91.74 246.4 92.26 246.4 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "249.43 94.01 259.81 88.02 270.18 94.01 270.18 94.01 271.08 93.49 271.08 93.49 259.81 86.98 248.53 93.49 248.53 93.49 249.43 94.01 249.43 94.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.51 100 194.86 87.5 194.86 62.5 216.51 50 238.16 62.5 238.16 87.5 216.51 100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "199.17 89.99 200.07 90.51 216.51 81.02 232.94 90.51 233.84 89.99 216.51 79.98 199.17 89.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "202.2 91.74 203.1 92.26 216.51 84.52 229.91 92.26 230.81 91.74 216.51 83.48 202.2 91.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "205.23 93.49 206.13 94.01 216.51 88.02 226.88 94.01 227.78 93.49 216.51 86.98 205.23 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "238.16 74.48 227.78 68.49 227.78 56.51 227.78 56.51 226.88 55.99 226.88 55.99 226.88 69.01 238.16 75.52 238.16 74.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "238.16 77.98 224.75 70.24 224.75 54.76 224.75 54.76 223.85 54.24 223.85 54.24 223.85 70.76 238.16 79.02 238.16 77.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "238.16 81.48 221.72 71.99 221.72 53.01 221.72 53.01 220.82 52.49 220.82 52.49 220.82 72.51 238.16 82.52 238.16 81.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "211.29 53.01 211.29 71.99 194.86 81.48 194.86 81.48 194.86 82.52 194.86 82.52 212.19 72.51 212.19 52.49 212.19 52.49 211.29 53.01 211.29 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "208.26 54.76 208.26 70.24 194.86 77.98 194.86 77.98 194.86 79.02 194.86 79.02 209.16 70.76 209.16 54.24 209.16 54.24 208.26 54.76 208.26 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "205.23 56.51 205.23 68.49 194.86 74.48 194.86 74.48 194.86 75.52 194.86 75.52 206.13 69.01 206.13 55.99 206.13 55.99 205.23 56.51 205.23 56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.21 100 151.55 87.5 151.55 62.5 173.21 50 194.86 62.5 194.86 87.5 173.21 100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "155.87 89.99 156.77 90.51 173.2 81.02 189.64 90.51 190.54 89.99 173.2 79.98 155.87 89.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "158.9 91.74 159.8 92.26 173.2 84.52 186.61 92.26 187.51 91.74 173.2 83.48 158.9 91.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.93 93.49 162.83 94.01 173.2 88.02 183.58 94.01 184.48 93.49 173.2 86.98 161.93 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "194.86 74.48 184.48 68.49 184.48 56.51 184.48 56.51 183.58 55.99 183.58 55.99 183.58 69.01 194.86 75.52 194.86 74.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "194.86 77.98 181.45 70.24 181.45 54.76 181.45 54.76 180.55 54.24 180.55 54.24 180.55 70.76 194.86 79.02 194.86 77.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "194.86 81.48 178.42 71.99 178.42 53.01 178.42 53.01 177.52 52.49 177.52 52.49 177.52 72.51 194.86 82.52 194.86 81.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "167.99 53.01 167.99 71.99 151.55 81.48 151.55 81.48 151.55 82.52 151.55 82.52 168.89 72.51 168.89 52.49 168.89 52.49 167.99 53.01 167.99 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "164.96 54.76 164.96 70.24 151.55 77.98 151.55 77.98 151.55 79.02 151.55 79.02 165.86 70.76 165.86 54.24 165.86 54.24 164.96 54.76 164.96 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "161.93 56.51 161.93 68.49 151.55 74.48 151.55 74.48 151.55 75.52 151.55 75.52 162.83 69.01 162.83 55.99 162.83 55.99 161.93 56.51 161.93 56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "151.55 62.5 151.55 87.5 129.9 100 108.25 87.5 108.25 62.5 129.9 50 151.55 62.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 82.52 151.55 81.48 135.12 71.99 135.12 53.01 134.22 52.49 134.22 72.51 151.55 82.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 79.02 151.55 77.98 138.15 70.24 138.15 54.76 137.25 54.24 137.25 70.76 151.55 79.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 75.52 151.55 74.48 141.18 68.49 141.18 56.51 140.28 55.99 140.28 69.01 151.55 75.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "118.63 56.51 118.63 68.49 108.25 74.48 108.25 74.48 108.25 75.52 108.25 75.52 119.53 69.01 119.53 55.99 118.63 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "121.66 54.76 121.66 70.24 108.25 77.98 108.25 77.98 108.25 79.02 108.25 79.02 122.56 70.76 122.56 54.24 121.66 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.69 53.01 124.69 71.99 108.25 81.48 108.25 81.48 108.25 82.52 108.25 82.52 125.59 72.51 125.59 52.49 124.69 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "113.47 90.51 129.9 81.02 146.34 90.51 146.34 90.51 147.24 89.99 147.24 89.99 129.9 79.98 112.57 89.99 112.57 89.99 113.47 90.51 113.47 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "116.5 92.26 129.9 84.52 143.31 92.26 143.31 92.26 144.21 91.74 144.21 91.74 129.9 83.48 115.6 91.74 115.6 91.74 116.5 92.26 116.5 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "119.53 94.01 129.9 88.02 140.28 94.01 140.28 94.01 141.18 93.49 141.18 93.49 129.9 86.98 118.63 93.49 118.63 93.49 119.53 94.01 119.53 94.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.6 100 64.95 87.5 64.95 62.5 86.6 50 108.25 62.5 108.25 87.5 86.6 100"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "69.27 89.99 70.17 90.51 86.6 81.02 103.04 90.51 103.94 89.99 86.6 79.98 69.27 89.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "72.3 91.74 73.2 92.26 86.6 84.52 100.01 92.26 100.91 91.74 86.6 83.48 72.3 91.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "75.33 93.49 76.23 94.01 86.6 88.02 96.98 94.01 97.88 93.49 86.6 86.98 75.33 93.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 74.48 97.88 68.49 97.88 56.51 97.88 56.51 96.98 55.99 96.98 55.99 96.98 69.01 108.25 75.52 108.25 74.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 77.98 94.85 70.24 94.85 54.76 94.85 54.76 93.95 54.24 93.95 54.24 93.95 70.76 108.25 79.02 108.25 77.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 81.48 91.82 71.99 91.82 53.01 91.82 53.01 90.92 52.49 90.92 52.49 90.92 72.51 108.25 82.52 108.25 81.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "81.39 53.01 81.39 71.99 64.95 81.48 64.95 81.48 64.95 82.52 64.95 82.52 82.29 72.51 82.29 52.49 82.29 52.49 81.39 53.01 81.39 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.36 54.76 78.36 70.24 64.95 77.98 64.95 77.98 64.95 79.02 64.95 79.02 79.26 70.76 79.26 54.24 79.26 54.24 78.36 54.76 78.36 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "75.33 56.51 75.33 68.49 64.95 74.48 64.95 74.48 64.95 75.52 64.95 75.52 76.23 69.01 76.23 55.99 76.23 55.99 75.33 56.51 75.33 56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.95 62.5 64.95 87.5 43.3 100 21.65 87.5 21.65 62.5 43.3 50 64.95 62.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "64.95 82.52 64.95 81.48 48.51 71.99 48.51 53.01 47.61 52.49 47.61 72.51 64.95 82.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "64.95 79.02 64.95 77.98 51.55 70.24 51.55 54.76 50.65 54.24 50.65 70.76 64.95 79.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "64.95 75.52 64.95 74.48 54.58 68.49 54.58 56.51 53.68 55.99 53.68 69.01 64.95 75.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "32.03 56.51 32.03 68.49 21.65 74.48 21.65 74.48 21.65 75.52 21.65 75.52 32.93 69.01 32.93 55.99 32.03 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.06 54.76 35.06 70.24 21.65 77.98 21.65 77.98 21.65 79.02 21.65 79.02 35.96 70.76 35.96 54.24 35.06 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "38.09 53.01 38.09 71.99 21.65 81.48 21.65 81.48 21.65 82.52 21.65 82.52 38.99 72.51 38.99 52.49 38.09 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "26.86 90.51 43.3 81.02 59.74 90.51 59.74 90.51 60.64 89.99 60.64 89.99 43.3 79.98 25.96 89.99 25.96 89.99 26.86 90.51 26.86 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "29.9 92.26 43.3 84.52 56.71 92.26 56.71 92.26 57.61 91.74 57.61 91.74 43.3 83.48 28.99 91.74 28.99 91.74 29.9 92.26 29.9 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "32.93 94.01 43.3 88.02 53.68 94.01 53.68 94.01 54.58 93.49 54.58 93.49 43.3 86.98 32.03 93.49 32.03 93.49 32.93 94.01 32.93 94.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "368.06 62.5 368.06 87.5 346.41 100 324.76 87.5 324.76 62.5 346.41 50 368.06 62.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "335.14 56.51 335.14 68.49 324.76 74.48 324.76 74.48 324.76 75.52 324.76 75.52 336.04 69.01 336.04 55.99 335.14 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "338.17 54.76 338.17 70.24 324.76 77.98 324.76 77.98 324.76 79.02 324.76 79.02 339.07 70.76 339.07 54.24 338.17 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "341.2 53.01 341.2 71.99 324.76 81.48 324.76 81.48 324.76 82.52 324.76 82.52 342.1 72.51 342.1 52.49 341.2 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "329.97 90.51 346.41 81.02 362.85 90.51 362.85 90.51 363.75 89.99 363.75 89.99 346.41 79.98 329.07 89.99 329.07 89.99 329.97 90.51 329.97 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "333 92.26 346.41 84.52 359.82 92.26 359.82 92.26 360.72 91.74 360.72 91.74 346.41 83.48 332.1 91.74 332.1 91.74 333 92.26 333 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "336.04 94.01 346.41 88.02 356.79 94.01 356.79 94.01 357.69 93.49 357.69 93.49 346.41 86.98 335.14 93.49 335.14 93.49 336.04 94.01 336.04 94.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.65 62.5 21.65 87.5 0 100 -21.65 87.5 -21.65 62.5 0 50 21.65 62.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "21.65 82.52 21.65 81.48 5.21 71.99 5.21 53.01 4.31 52.49 4.31 72.51 21.65 82.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "21.65 79.02 21.65 77.98 8.24 70.24 8.24 54.76 7.34 54.24 7.34 70.76 21.65 79.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "21.65 75.52 21.65 74.48 11.28 68.49 11.28 56.51 10.38 55.99 10.38 69.01 21.65 75.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-16.44 90.51 0 81.02 16.44 90.51 16.44 90.51 17.34 89.99 17.34 89.99 0 79.98 -17.34 89.99 -17.34 89.99 -16.44 90.51 -16.44 90.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-13.41 92.26 0 84.52 13.41 92.26 13.41 92.26 14.31 91.74 14.31 91.74 0 83.48 -14.31 91.74 -14.31 91.74 -13.41 92.26 -13.41 92.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "-10.38 94.01 0 88.02 10.38 94.01 10.38 94.01 11.28 93.49 11.28 93.49 0 86.98 -11.28 93.49 -11.28 93.49 -10.38 94.01 -10.38 94.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "324.76 62.5 303.11 50 303.11 25 324.76 12.5 346.41 25 346.41 50 324.76 62.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "307.42 52.49 308.32 53.01 324.76 43.52 341.2 53.01 342.1 52.49 324.76 42.48 307.42 52.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "310.45 54.24 311.35 54.76 324.76 47.02 338.17 54.76 339.07 54.24 324.76 45.98 310.45 54.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.48 55.99 314.38 56.51 324.76 50.52 335.13 56.51 336.03 55.99 324.76 49.48 313.48 55.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "346.41 36.98 336.03 30.99 336.03 19.01 336.04 19.01 335.14 18.49 335.13 18.49 335.13 31.51 346.41 38.02 346.41 36.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "346.41 40.48 333 32.74 333 17.26 333 17.26 332.1 16.74 332.1 16.74 332.1 33.26 346.41 41.52 346.41 40.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "346.41 43.98 329.97 34.49 329.97 15.51 329.97 15.51 329.07 14.99 329.07 14.99 329.07 35.01 346.41 45.02 346.41 43.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "319.55 15.51 319.55 34.49 303.11 43.98 303.11 43.98 303.11 45.02 303.11 45.02 320.45 35.01 320.45 14.99 320.45 14.99 319.55 15.51 319.55 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "316.52 17.26 316.52 32.74 303.11 40.48 303.11 40.48 303.11 41.52 303.11 41.52 317.42 33.26 317.42 16.74 317.42 16.74 316.52 17.26 316.52 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "313.48 19.01 313.48 30.99 303.11 36.98 303.11 36.98 303.11 38.02 303.11 38.02 314.38 31.51 314.38 18.49 314.38 18.49 313.48 19.01 313.48 19.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "303.11 25 303.11 50 281.46 62.5 259.81 50 259.81 25 281.46 12.5 303.11 25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 45.02 303.11 43.98 286.67 34.49 286.67 15.51 285.77 14.99 285.77 35.01 303.11 45.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 41.52 303.11 40.48 289.7 32.74 289.7 17.26 288.8 16.74 288.8 33.26 303.11 41.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "303.11 38.02 303.11 36.98 292.73 30.99 292.73 19.01 291.83 18.49 291.83 31.51 303.11 38.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "270.18 19.01 270.18 30.99 259.81 36.98 259.81 36.98 259.81 38.02 259.81 38.02 271.08 31.51 271.08 18.49 270.18 19.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "273.21 17.26 273.21 32.74 259.81 40.48 259.81 40.48 259.81 41.52 259.81 41.52 274.11 33.26 274.11 16.74 273.21 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "276.25 15.51 276.25 34.49 259.81 43.98 259.81 43.98 259.81 45.02 259.81 45.02 277.15 35.01 277.15 14.99 276.25 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "265.02 53.01 281.46 43.52 297.9 53.01 297.9 53.01 298.8 52.49 298.8 52.49 281.46 42.48 264.12 52.49 264.12 52.49 265.02 53.01 265.02 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "268.05 54.76 281.46 47.02 294.87 54.76 294.87 54.76 295.76 54.24 295.76 54.24 281.46 45.98 267.15 54.24 267.15 54.24 268.05 54.76 268.05 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "271.08 56.51 281.46 50.52 291.83 56.51 291.83 56.51 292.73 55.99 292.73 55.99 281.46 49.48 270.18 55.99 270.18 55.99 271.08 56.51 271.08 56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "259.81 50 238.16 62.5 216.51 50 216.51 25 238.16 12.5 259.81 25 259.81 50"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "242.47 60.01 243.37 59.49 243.37 40.51 259.81 31.02 259.81 29.98 242.47 39.99 242.47 60.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "245.5 58.26 246.4 57.74 246.4 42.26 259.81 34.52 259.81 33.48 245.5 41.74 245.5 58.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "248.53 56.51 249.43 55.99 249.43 44.01 259.81 38.02 259.81 36.98 248.53 43.49 248.53 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "248.53 18.49 238.16 24.48 227.78 18.49 227.78 18.49 226.88 19.01 226.88 19.01 238.16 25.52 249.43 19.01 248.53 18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "251.56 20.24 238.16 27.98 224.75 20.24 224.75 20.24 223.85 20.76 223.85 20.76 238.16 29.02 252.46 20.76 251.56 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "254.59 21.99 238.16 31.48 221.72 21.99 221.72 21.99 220.82 22.51 220.82 22.51 238.16 32.52 255.49 22.51 254.59 21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "216.51 31.02 232.94 40.51 232.94 59.49 232.94 59.49 233.84 60.01 233.84 60.01 233.84 39.99 216.51 29.98 216.51 29.98 216.51 31.02 216.51 31.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "216.51 34.52 229.91 42.26 229.91 57.74 229.91 57.74 230.81 58.26 230.81 58.26 230.81 41.74 216.51 33.48 216.51 33.48 216.51 34.52 216.51 34.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "216.51 38.02 226.88 44.01 226.88 55.99 226.88 55.99 227.78 56.51 227.78 56.51 227.78 43.49 216.51 36.98 216.51 36.98 216.51 38.02 216.51 38.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.51 25 216.51 50 194.86 62.5 173.21 50 173.21 25 194.86 12.5 216.51 25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "216.51 45.02 216.51 43.98 200.07 34.49 200.07 15.51 199.17 14.99 199.17 35.01 216.51 45.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "216.51 41.52 216.51 40.48 203.1 32.74 203.1 17.26 202.2 16.74 202.2 33.26 216.51 41.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "216.51 38.02 216.51 36.98 206.13 30.99 206.13 19.01 205.23 18.49 205.23 31.51 216.51 38.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "183.58 19.01 183.58 30.99 173.21 36.98 173.21 36.98 173.21 38.02 173.21 38.02 184.48 31.51 184.48 18.49 183.58 19.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "186.61 17.26 186.61 32.74 173.21 40.48 173.21 40.48 173.21 41.52 173.21 41.52 187.51 33.26 187.51 16.74 186.61 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "189.64 15.51 189.64 34.49 173.21 43.98 173.21 43.98 173.21 45.02 173.21 45.02 190.54 35.01 190.54 14.99 189.64 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "178.42 53.01 194.86 43.52 211.29 53.01 211.29 53.01 212.19 52.49 212.19 52.49 194.86 42.48 177.52 52.49 177.52 52.49 178.42 53.01 178.42 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "181.45 54.76 194.86 47.02 208.26 54.76 208.26 54.76 209.16 54.24 209.16 54.24 194.86 45.98 180.55 54.24 180.55 54.24 181.45 54.76 181.45 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "184.48 56.51 194.86 50.52 205.23 56.51 205.23 56.51 206.13 55.99 206.13 55.99 194.86 49.48 183.58 55.99 183.58 55.99 184.48 56.51 184.48 56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.21 50 151.55 62.5 129.9 50 129.9 25 151.55 12.5 173.21 25 173.21 50"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "155.87 60.01 156.77 59.49 156.77 40.51 173.21 31.02 173.21 29.98 155.87 39.99 155.87 60.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "158.9 58.26 159.8 57.74 159.8 42.26 173.21 34.52 173.21 33.48 158.9 41.74 158.9 58.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "161.93 56.51 162.83 55.99 162.83 44.01 173.21 38.02 173.21 36.98 161.93 43.49 161.93 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.93 18.49 151.55 24.48 141.18 18.49 141.18 18.49 140.28 19.01 140.28 19.01 151.55 25.52 162.83 19.01 161.93 18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.96 20.24 151.55 27.98 138.15 20.24 138.15 20.24 137.25 20.76 137.25 20.76 151.55 29.02 165.86 20.76 164.96 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "167.99 21.99 151.55 31.48 135.12 21.99 135.12 21.99 134.22 22.51 134.22 22.51 151.55 32.52 168.89 22.51 167.99 21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 31.02 146.34 40.51 146.34 59.49 146.34 59.49 147.24 60.01 147.24 60.01 147.24 39.99 129.9 29.98 129.9 29.98 129.9 31.02 129.9 31.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 34.52 143.31 42.26 143.31 57.74 143.31 57.74 144.21 58.26 144.21 58.26 144.21 41.74 129.9 33.48 129.9 33.48 129.9 34.52 129.9 34.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "129.9 38.02 140.28 44.01 140.28 55.99 140.28 55.99 141.18 56.51 141.18 56.51 141.18 43.49 129.9 36.98 129.9 36.98 129.9 38.02 129.9 38.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.25 62.5 86.6 50 86.6 25 108.25 12.5 129.9 25 129.9 50 108.25 62.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "90.92 52.49 91.82 53.01 108.25 43.52 124.69 53.01 125.59 52.49 108.25 42.48 90.92 52.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "93.95 54.24 94.85 54.76 108.25 47.02 121.66 54.76 122.56 54.24 108.25 45.98 93.95 54.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "96.98 55.99 97.88 56.51 108.25 50.52 118.63 56.51 119.53 55.99 108.25 49.48 96.98 55.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.9 36.98 119.53 30.99 119.53 19.01 119.53 19.01 118.63 18.49 118.63 18.49 118.63 31.51 129.9 38.02 129.9 36.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.9 40.48 116.5 32.74 116.5 17.26 116.5 17.26 115.6 16.74 115.6 16.74 115.6 33.26 129.9 41.52 129.9 40.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "129.9 43.98 113.47 34.49 113.47 15.51 113.47 15.51 112.57 14.99 112.57 14.99 112.57 35.01 129.9 45.02 129.9 43.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "103.04 15.51 103.04 34.49 86.6 43.98 86.6 43.98 86.6 45.02 86.6 45.02 103.94 35.01 103.94 14.99 103.94 14.99 103.04 15.51 103.04 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "100.01 17.26 100.01 32.74 86.6 40.48 86.6 40.48 86.6 41.52 86.6 41.52 100.91 33.26 100.91 16.74 100.91 16.74 100.01 17.26 100.01 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "96.98 19.01 96.98 30.99 86.6 36.98 86.6 36.98 86.6 38.02 86.6 38.02 97.88 31.51 97.88 18.49 97.88 18.49 96.98 19.01 96.98 19.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.6 25 86.6 50 64.95 62.5 43.3 50 43.3 25 64.95 12.5 86.6 25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.6 45.02 86.6 43.98 70.17 34.49 70.17 15.51 69.27 14.99 69.27 35.01 86.6 45.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.6 41.52 86.6 40.48 73.2 32.74 73.2 17.26 72.3 16.74 72.3 33.26 86.6 41.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.6 38.02 86.6 36.98 76.23 30.99 76.23 19.01 75.33 18.49 75.33 31.51 86.6 38.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.68 19.01 53.68 30.99 43.3 36.98 43.3 36.98 43.3 38.02 43.3 38.02 54.58 31.51 54.58 18.49 53.68 19.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "56.71 17.26 56.71 32.74 43.3 40.48 43.3 40.48 43.3 41.52 43.3 41.52 57.61 33.26 57.61 16.74 56.71 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "59.74 15.51 59.74 34.49 43.3 43.98 43.3 43.98 43.3 45.02 43.3 45.02 60.64 35.01 60.64 14.99 59.74 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "48.51 53.01 64.95 43.52 81.39 53.01 81.39 53.01 82.29 52.49 82.29 52.49 64.95 42.48 47.61 52.49 47.61 52.49 48.51 53.01 48.51 53.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "51.55 54.76 64.95 47.02 78.36 54.76 78.36 54.76 79.26 54.24 79.26 54.24 64.95 45.98 50.65 54.24 50.65 54.24 51.55 54.76 51.55 54.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "54.58 56.51 64.95 50.52 75.33 56.51 75.33 56.51 76.23 55.99 76.23 55.99 64.95 49.48 53.68 55.99 53.68 55.99 54.58 56.51 54.58 56.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.3 50 21.65 62.5 0 50 0 25 21.65 12.5 43.3 25 43.3 50"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "25.96 60.01 26.86 59.49 26.86 40.51 43.3 31.02 43.3 29.98 25.96 39.99 25.96 60.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.99 58.26 29.9 57.74 29.89 42.26 43.3 34.52 43.3 33.48 29 41.74 28.99 58.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "32.03 56.51 32.93 55.99 32.93 44.01 43.3 38.02 43.3 36.98 32.03 43.49 32.03 56.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "32.03 18.49 21.65 24.48 11.28 18.49 11.28 18.49 10.38 19.01 10.38 19.01 21.65 25.52 32.93 19.01 32.03 18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "35.06 20.24 21.65 27.98 8.24 20.24 8.24 20.24 7.34 20.76 7.34 20.76 21.65 29.02 35.96 20.76 35.06 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "38.09 21.99 21.65 31.48 5.21 21.99 5.21 21.99 4.31 22.51 4.31 22.51 21.65 32.52 38.99 22.51 38.09 21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 31.02 16.44 40.51 16.44 59.49 16.44 59.49 17.34 60.01 17.34 60.01 17.34 39.99 0 29.98 0 29.98 0 31.02 0 31.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 34.52 13.41 42.26 13.41 57.74 13.41 57.74 14.31 58.26 14.31 58.26 14.31 41.74 0 33.48 0 33.48 0 34.52 0 34.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 38.02 10.38 44.01 10.38 55.99 10.38 55.99 11.28 56.51 11.28 56.51 11.28 43.49 0 36.98 0 36.98 0 38.02 0 38.02"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "324.76 237.5 303.11 250 281.46 237.5 281.46 212.5 303.11 200 324.76 212.5 324.76 237.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "307.42 247.51 308.32 246.99 308.32 228.01 324.76 218.52 324.76 217.48 307.42 227.49 307.42 247.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "310.45 245.76 311.35 245.24 311.35 229.76 324.76 222.02 324.76 220.98 310.45 229.24 310.45 245.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.48 244.01 314.38 243.49 314.38 231.51 324.76 225.52 324.76 224.48 313.48 230.99 313.48 244.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "313.48 205.99 303.11 211.98 292.73 205.99 292.73 205.99 291.83 206.51 291.83 206.51 303.11 213.02 314.38 206.51 313.48 205.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "316.52 207.74 303.11 215.48 289.7 207.74 289.7 207.74 288.8 208.26 288.8 208.26 303.11 216.52 317.42 208.26 316.52 207.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "319.55 209.49 303.11 218.98 286.67 209.49 286.67 209.49 285.77 210.01 285.77 210.01 303.11 220.02 320.45 210.01 319.55 209.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 218.52 297.9 228.01 297.9 246.99 297.9 246.99 298.8 247.51 298.8 247.51 298.8 227.49 281.46 217.48 281.46 217.48 281.46 218.52 281.46 218.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 222.02 294.87 229.76 294.87 245.24 294.87 245.24 295.76 245.76 295.77 245.76 295.77 229.24 281.46 220.98 281.46 220.98 281.46 222.02 281.46 222.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 225.52 291.83 231.51 291.83 243.49 291.83 243.49 292.73 244.01 292.73 244.01 292.73 230.99 281.46 224.48 281.46 224.48 281.46 225.52 281.46 225.52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "324.76 12.5 303.11 25 281.46 12.5 281.46 -12.5 303.11 -25 324.76 -12.5 324.76 12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "307.42 22.51 308.32 21.99 308.32 3.01 324.76 -6.48 324.76 -7.52 307.42 2.49 307.42 22.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "310.45 20.76 311.35 20.24 311.35 4.76 324.76 -2.98 324.76 -4.02 310.45 4.24 310.45 20.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "313.48 19.01 314.38 18.49 314.38 6.51 324.76 .52 324.76 -.52 313.48 5.99 313.48 19.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 -6.48 297.9 3.01 297.9 21.99 297.9 21.99 298.8 22.51 298.8 22.51 298.8 2.49 281.46 -7.52 281.46 -7.52 281.46 -6.48 281.46 -6.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 -2.98 294.87 4.76 294.87 20.24 294.87 20.24 295.76 20.76 295.77 20.76 295.77 4.24 281.46 -4.02 281.46 -4.02 281.46 -2.98 281.46 -2.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "281.46 .52 291.83 6.51 291.83 18.49 291.83 18.49 292.73 19.01 292.73 19.01 292.73 5.99 281.46 -.52 281.46 -.52 281.46 .52 281.46 .52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "281.46 212.5 281.46 237.5 259.81 250 238.16 237.5 238.16 212.5 259.81 200 281.46 212.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 232.52 281.46 231.48 265.02 221.99 265.02 203.01 264.12 202.49 264.12 222.51 281.46 232.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 229.02 281.46 227.98 268.05 220.24 268.05 204.76 267.15 204.24 267.15 220.76 281.46 229.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 225.52 281.46 224.48 271.08 218.49 271.08 206.51 270.18 205.99 270.18 219.01 281.46 225.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "248.53 206.51 248.53 218.49 238.16 224.48 238.16 224.48 238.16 225.52 238.16 225.52 249.43 219.01 249.43 205.99 248.53 206.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "251.56 204.76 251.56 220.24 238.16 227.98 238.16 227.98 238.16 229.02 238.16 229.02 252.46 220.76 252.46 204.24 251.56 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "254.59 203.01 254.59 221.99 238.16 231.48 238.16 231.48 238.16 232.52 238.16 232.52 255.49 222.51 255.49 202.49 254.59 203.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "281.46 -12.5 281.46 12.5 259.81 25 238.16 12.5 238.16 -12.5 259.81 -25 281.46 -12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 7.52 281.46 6.48 265.02 -3.01 265.02 -21.99 264.12 -22.51 264.12 -2.49 281.46 7.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 4.02 281.46 2.98 268.05 -4.76 268.05 -20.24 267.15 -20.76 267.15 -4.24 281.46 4.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "281.46 .52 281.46 -.52 271.08 -6.51 271.08 -18.49 270.18 -19.01 270.18 -5.99 281.46 .52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "248.53 -18.49 248.53 -6.51 238.16 -.52 238.16 -.52 238.16 .52 238.16 .52 249.43 -5.99 249.43 -19.01 248.53 -18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "251.56 -20.24 251.56 -4.76 238.16 2.98 238.16 2.98 238.16 4.02 238.16 4.02 252.46 -4.24 252.46 -20.76 251.56 -20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "254.59 -21.99 254.59 -3.01 238.16 6.48 238.16 6.48 238.16 7.52 238.16 7.52 255.49 -2.49 255.49 -22.51 254.59 -21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "243.37 15.51 259.81 6.02 276.25 15.51 276.25 15.51 277.15 14.99 277.15 14.99 259.81 4.98 242.47 14.99 242.47 14.99 243.37 15.51 243.37 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "246.4 17.26 259.81 9.52 273.21 17.26 273.21 17.26 274.11 16.74 274.11 16.74 259.81 8.48 245.5 16.74 245.5 16.74 246.4 17.26 246.4 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "249.43 19.01 259.81 13.02 270.18 19.01 270.18 19.01 271.08 18.49 271.08 18.49 259.81 11.98 248.53 18.49 248.53 18.49 249.43 19.01 249.43 19.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "238.16 237.5 216.51 250 194.86 237.5 194.86 212.5 216.51 200 238.16 212.5 238.16 237.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.82 247.51 221.72 246.99 221.72 228.01 238.16 218.52 238.16 217.48 220.82 227.49 220.82 247.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "223.85 245.76 224.75 245.24 224.75 229.76 238.16 222.02 238.16 220.98 223.85 229.24 223.85 245.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "226.88 244.01 227.78 243.49 227.78 231.51 238.16 225.52 238.16 224.48 226.88 230.99 226.88 244.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "226.88 205.99 216.51 211.98 206.13 205.99 206.13 205.99 205.23 206.51 205.23 206.51 216.51 213.02 227.78 206.51 226.88 205.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "229.91 207.74 216.51 215.48 203.1 207.74 203.1 207.74 202.2 208.26 202.2 208.26 216.51 216.52 230.81 208.26 229.91 207.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "232.94 209.49 216.51 218.98 200.07 209.49 200.07 209.49 199.17 210.01 199.17 210.01 216.51 220.02 233.84 210.01 232.94 209.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.86 218.52 211.29 228.01 211.29 246.99 211.29 246.99 212.19 247.51 212.19 247.51 212.19 227.49 194.86 217.48 194.86 217.48 194.86 218.52 194.86 218.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.86 222.02 208.26 229.76 208.26 245.24 208.26 245.24 209.16 245.76 209.16 245.76 209.16 229.24 194.86 220.98 194.86 220.98 194.86 222.02 194.86 222.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.86 225.52 205.23 231.51 205.23 243.49 205.23 243.49 206.13 244.01 206.13 244.01 206.13 230.99 194.86 224.48 194.86 224.48 194.86 225.52 194.86 225.52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "238.16 12.5 216.51 25 194.86 12.5 194.86 -12.5 216.51 -25 238.16 -12.5 238.16 12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "220.82 22.51 221.72 21.99 221.72 3.01 238.16 -6.48 238.16 -7.52 220.82 2.49 220.82 22.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "223.85 20.76 224.75 20.24 224.75 4.76 238.16 -2.98 238.16 -4.02 223.85 4.24 223.85 20.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "226.88 19.01 227.78 18.49 227.78 6.51 238.16 .52 238.16 -.52 226.88 5.99 226.88 19.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.86 -6.48 211.29 3.01 211.29 21.99 211.29 21.99 212.19 22.51 212.19 22.51 212.19 2.49 194.86 -7.52 194.86 -7.52 194.86 -6.48 194.86 -6.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.86 -2.98 208.26 4.76 208.26 20.24 208.26 20.24 209.16 20.76 209.16 20.76 209.16 4.24 194.86 -4.02 194.86 -4.02 194.86 -2.98 194.86 -2.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.86 .52 205.23 6.51 205.23 18.49 205.23 18.49 206.13 19.01 206.13 19.01 206.13 5.99 194.86 -.52 194.86 -.52 194.86 .52 194.86 .52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "194.86 212.5 194.86 237.5 173.21 250 151.55 237.5 151.55 212.5 173.21 200 194.86 212.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 232.52 194.86 231.48 178.42 221.99 178.42 203.01 177.52 202.49 177.52 222.51 194.86 232.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 229.02 194.86 227.98 181.45 220.24 181.45 204.76 180.55 204.24 180.55 220.76 194.86 229.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 225.52 194.86 224.48 184.48 218.49 184.48 206.51 183.58 205.99 183.58 219.01 194.86 225.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.93 206.51 161.93 218.49 151.55 224.48 151.55 224.48 151.55 225.52 151.56 225.52 162.83 219.01 162.83 205.99 161.93 206.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.96 204.76 164.96 220.24 151.55 227.98 151.55 227.98 151.55 229.02 151.55 229.02 165.86 220.76 165.86 204.24 164.96 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "167.99 203.01 167.99 221.99 151.55 231.48 151.55 231.48 151.55 232.52 151.56 232.52 168.89 222.51 168.89 202.49 167.99 203.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "194.86 -12.5 194.86 12.5 173.21 25 151.55 12.5 151.55 -12.5 173.21 -25 194.86 -12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 7.52 194.86 6.48 178.42 -3.01 178.42 -21.99 177.52 -22.51 177.52 -2.49 194.86 7.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 4.02 194.86 2.98 181.45 -4.76 181.45 -20.24 180.55 -20.76 180.55 -4.24 194.86 4.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "194.86 .52 194.86 -.52 184.48 -6.51 184.48 -18.49 183.58 -19.01 183.58 -5.99 194.86 .52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161.93 -18.49 161.93 -6.51 151.55 -.52 151.55 -.52 151.55 .52 151.56 .52 162.83 -5.99 162.83 -19.01 161.93 -18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "164.96 -20.24 164.96 -4.76 151.55 2.98 151.55 2.98 151.55 4.02 151.55 4.02 165.86 -4.24 165.86 -20.76 164.96 -20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "167.99 -21.99 167.99 -3.01 151.55 6.48 151.55 6.48 151.55 7.52 151.56 7.52 168.89 -2.49 168.89 -22.51 167.99 -21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "156.77 15.51 173.21 6.02 189.64 15.51 189.64 15.51 190.54 14.99 190.54 14.99 173.21 4.98 155.87 14.99 155.87 14.99 156.77 15.51 156.77 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "159.8 17.26 173.21 9.52 186.61 17.26 186.61 17.26 187.51 16.74 187.51 16.74 173.21 8.48 158.9 16.74 158.9 16.74 159.8 17.26 159.8 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "162.83 19.01 173.21 13.02 183.58 19.01 183.58 19.01 184.48 18.49 184.48 18.49 173.21 11.98 161.93 18.49 161.93 18.49 162.83 19.01 162.83 19.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "151.55 212.5 151.55 237.5 129.9 250 108.25 237.5 108.25 212.5 129.9 200 151.55 212.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 232.52 151.55 231.48 135.12 221.99 135.12 203.01 134.22 202.49 134.22 222.51 151.55 232.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 229.02 151.55 227.98 138.15 220.24 138.15 204.76 137.25 204.24 137.25 220.76 151.55 229.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 225.52 151.55 224.48 141.18 218.49 141.18 206.51 140.28 205.99 140.28 219.01 151.55 225.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "118.63 206.51 118.63 218.49 108.25 224.48 108.25 224.48 108.25 225.52 108.25 225.52 119.53 219.01 119.53 205.99 118.63 206.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "121.66 204.76 121.66 220.24 108.25 227.98 108.25 227.98 108.25 229.02 108.25 229.02 122.56 220.76 122.56 204.24 121.66 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.69 203.01 124.69 221.99 108.25 231.48 108.25 231.48 108.25 232.52 108.25 232.52 125.59 222.51 125.59 202.49 124.69 203.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "151.55 -12.5 151.55 12.5 129.9 25 108.25 12.5 108.25 -12.5 129.9 -25 151.55 -12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 7.52 151.55 6.48 135.12 -3.01 135.12 -21.99 134.22 -22.51 134.22 -2.49 151.55 7.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 4.02 151.55 2.98 138.15 -4.76 138.15 -20.24 137.25 -20.76 137.25 -4.24 151.55 4.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "151.55 .52 151.55 -.52 141.18 -6.51 141.18 -18.49 140.28 -19.01 140.28 -5.99 151.55 .52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "118.63 -18.49 118.63 -6.51 108.25 -.52 108.25 -.52 108.25 .52 108.25 .52 119.53 -5.99 119.53 -19.01 118.63 -18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "121.66 -20.24 121.66 -4.76 108.25 2.98 108.25 2.98 108.25 4.02 108.25 4.02 122.56 -4.24 122.56 -20.76 121.66 -20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "124.69 -21.99 124.69 -3.01 108.25 6.48 108.25 6.48 108.25 7.52 108.25 7.52 125.59 -2.49 125.59 -22.51 124.69 -21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "113.47 15.51 129.9 6.02 146.34 15.51 146.34 15.51 147.24 14.99 147.24 14.99 129.9 4.98 112.57 14.99 112.57 14.99 113.47 15.51 113.47 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "116.5 17.26 129.9 9.52 143.31 17.26 143.31 17.26 144.21 16.74 144.21 16.74 129.9 8.48 115.6 16.74 115.6 16.74 116.5 17.26 116.5 17.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "119.53 19.01 129.9 13.02 140.28 19.01 140.28 19.01 141.18 18.49 141.18 18.49 129.9 11.98 118.63 18.49 118.63 18.49 119.53 19.01 119.53 19.01"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.6 250 64.95 237.5 64.95 212.5 86.6 200 108.25 212.5 108.25 237.5 86.6 250"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 224.48 97.88 218.49 97.88 206.51 97.88 206.51 96.98 205.99 96.98 205.99 96.98 219.01 108.25 225.52 108.25 224.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 227.98 94.85 220.24 94.85 204.76 94.85 204.76 93.95 204.24 93.95 204.24 93.95 220.76 108.25 229.02 108.25 227.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 231.48 91.82 221.99 91.82 203.01 91.82 203.01 90.92 202.49 90.92 202.49 90.92 222.51 108.25 232.52 108.25 231.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "81.39 203.01 81.39 221.99 64.95 231.48 64.95 231.48 64.95 232.52 64.95 232.52 82.29 222.51 82.29 202.49 82.29 202.49 81.39 203.01 81.39 203.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.36 204.76 78.36 220.24 64.95 227.98 64.95 227.98 64.95 229.02 64.95 229.02 79.26 220.76 79.26 204.24 79.26 204.24 78.36 204.76 78.36 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "75.33 206.51 75.33 218.49 64.95 224.48 64.95 224.48 64.95 225.52 64.95 225.52 76.23 219.01 76.23 205.99 76.23 205.99 75.33 206.51 75.33 206.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.6 25 64.95 12.5 64.95 -12.5 86.6 -25 108.25 -12.5 108.25 12.5 86.6 25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "69.27 14.99 70.17 15.51 86.6 6.02 103.04 15.51 103.94 14.99 86.6 4.98 69.27 14.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "72.3 16.74 73.2 17.26 86.6 9.52 100.01 17.26 100.91 16.74 86.6 8.48 72.3 16.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "75.33 18.49 76.23 19.01 86.6 13.02 96.98 19.01 97.88 18.49 86.6 11.98 75.33 18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 -.52 97.88 -6.51 97.88 -18.49 97.88 -18.49 96.98 -19.01 96.98 -19.01 96.98 -5.99 108.25 .52 108.25 -.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 2.98 94.85 -4.76 94.85 -20.24 94.85 -20.24 93.95 -20.76 93.95 -20.76 93.95 -4.24 108.25 4.02 108.25 2.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "108.25 6.48 91.82 -3.01 91.82 -21.99 91.82 -21.99 90.92 -22.51 90.92 -22.51 90.92 -2.49 108.25 7.52 108.25 6.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "81.39 -21.99 81.39 -3.01 64.95 6.48 64.95 6.48 64.95 7.52 64.95 7.52 82.29 -2.49 82.29 -22.51 82.29 -22.51 81.39 -21.99 81.39 -21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "78.36 -20.24 78.36 -4.76 64.95 2.98 64.95 2.98 64.95 4.02 64.95 4.02 79.26 -4.24 79.26 -20.76 79.26 -20.76 78.36 -20.24 78.36 -20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "75.33 -18.49 75.33 -6.51 64.95 -.52 64.95 -.52 64.95 .52 64.95 .52 76.23 -5.99 76.23 -19.01 76.23 -19.01 75.33 -18.49 75.33 -18.49"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.3 250 21.65 237.5 21.65 212.5 43.3 200 64.95 212.5 64.95 237.5 43.3 250"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 224.48 54.58 218.49 54.58 206.51 54.58 206.51 53.68 205.99 53.68 205.99 53.68 219.01 64.95 225.52 64.95 224.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 227.98 51.55 220.24 51.55 204.76 51.55 204.76 50.65 204.24 50.65 204.24 50.65 220.76 64.95 229.02 64.95 227.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 231.48 48.51 221.99 48.51 203.01 48.51 203.01 47.61 202.49 47.61 202.49 47.61 222.51 64.95 232.52 64.95 231.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "38.09 203.01 38.09 221.99 21.65 231.48 21.65 231.48 21.65 232.52 21.65 232.52 38.99 222.51 38.99 202.49 38.99 202.49 38.09 203.01 38.09 203.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.06 204.76 35.06 220.24 21.65 227.98 21.65 227.98 21.65 229.02 21.65 229.02 35.96 220.76 35.96 204.24 35.96 204.24 35.06 204.76 35.06 204.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "32.03 206.51 32.03 218.49 21.65 224.48 21.65 224.48 21.65 225.52 21.65 225.52 32.93 219.01 32.93 205.99 32.93 205.99 32.03 206.51 32.03 206.51"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.3 25 21.65 12.5 21.65 -12.5 43.3 -25 64.95 -12.5 64.95 12.5 43.3 25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "25.96 14.99 26.86 15.51 43.3 6.02 59.74 15.51 60.64 14.99 43.3 4.98 25.96 14.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "28.99 16.74 29.9 17.26 43.3 9.52 56.71 17.26 57.61 16.74 43.3 8.48 28.99 16.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "32.03 18.49 32.93 19.01 43.3 13.02 53.68 19.01 54.58 18.49 43.3 11.98 32.03 18.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 -.52 54.58 -6.51 54.58 -18.49 54.58 -18.49 53.68 -19.01 53.68 -19.01 53.68 -5.99 64.95 .52 64.95 -.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 2.98 51.55 -4.76 51.55 -20.24 51.55 -20.24 50.65 -20.76 50.65 -20.76 50.65 -4.24 64.95 4.02 64.95 2.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.95 6.48 48.51 -3.01 48.51 -21.99 48.51 -21.99 47.61 -22.51 47.61 -22.51 47.61 -2.49 64.95 7.52 64.95 6.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "38.09 -21.99 38.09 -3.01 21.65 6.48 21.65 6.48 21.65 7.52 21.65 7.52 38.99 -2.49 38.99 -22.51 38.99 -22.51 38.09 -21.99 38.09 -21.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "35.06 -20.24 35.06 -4.76 21.65 2.98 21.65 2.98 21.65 4.02 21.65 4.02 35.96 -4.24 35.96 -20.76 35.96 -20.76 35.06 -20.24 35.06 -20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "32.03 -18.49 32.03 -6.51 21.65 -.52 21.65 -.52 21.65 .52 21.65 .52 32.93 -5.99 32.93 -19.01 32.93 -19.01 32.03 -18.49 32.03 -18.49"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "368.06 237.5 346.41 250 324.76 237.5 324.76 212.5 346.41 200 368.06 212.5 368.06 237.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "356.79 205.99 346.41 211.98 336.04 205.99 336.04 205.99 335.14 206.51 335.14 206.51 346.41 213.02 357.69 206.51 356.79 205.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "359.82 207.74 346.41 215.48 333 207.74 333 207.74 332.1 208.26 332.1 208.26 346.41 216.52 360.72 208.26 359.82 207.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "362.85 209.49 346.41 218.98 329.97 209.49 329.97 209.49 329.07 210.01 329.07 210.01 346.41 220.02 363.75 210.01 362.85 209.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "324.76 218.52 341.2 228.01 341.2 246.99 341.2 246.99 342.1 247.51 342.1 247.51 342.1 227.49 324.76 217.48 324.76 217.48 324.76 218.52 324.76 218.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "324.76 222.02 338.17 229.76 338.17 245.24 338.17 245.24 339.07 245.76 339.07 245.76 339.07 229.24 324.76 220.98 324.76 220.98 324.76 222.02 324.76 222.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "324.76 225.52 335.14 231.51 335.14 243.49 335.14 243.49 336.04 244.01 336.04 244.01 336.04 230.99 324.76 224.48 324.76 224.48 324.76 225.52 324.76 225.52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.65 237.5 0 250 -21.65 237.5 -21.65 212.5 0 200 21.65 212.5 21.65 237.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "4.31 247.51 5.21 246.99 5.21 228.01 21.65 218.52 21.65 217.48 4.31 227.49 4.31 247.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "7.34 245.76 8.24 245.24 8.24 229.76 21.65 222.02 21.65 220.98 7.34 229.24 7.34 245.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "10.38 244.01 11.28 243.49 11.28 231.51 21.65 225.52 21.65 224.48 10.38 230.99 10.38 244.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.38 205.99 0 211.98 -10.38 205.99 -10.38 205.99 -11.28 206.51 -11.28 206.51 0 213.02 11.28 206.51 10.38 205.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "13.41 207.74 0 215.48 -13.41 207.74 -13.41 207.74 -14.31 208.26 -14.31 208.26 0 216.52 14.31 208.26 13.41 207.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "16.44 209.49 0 218.98 -16.44 209.49 -16.44 209.49 -17.34 210.01 -17.34 210.01 0 220.02 17.34 210.01 16.44 209.49"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "368.06 12.5 346.41 25 324.76 12.5 324.76 -12.5 346.41 -25 368.06 -12.5 368.06 12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "324.76 -6.48 341.2 3.01 341.2 21.99 341.2 21.99 342.1 22.51 342.1 22.51 342.1 2.49 324.76 -7.52 324.76 -7.52 324.76 -6.48 324.76 -6.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "324.76 -2.98 338.17 4.76 338.17 20.24 338.17 20.24 339.07 20.76 339.07 20.76 339.07 4.24 324.76 -4.02 324.76 -4.02 324.76 -2.98 324.76 -2.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "324.76 .52 335.14 6.51 335.14 18.49 335.14 18.49 336.04 19.01 336.04 19.01 336.04 5.99 324.76 -.52 324.76 -.52 324.76 .52 324.76 .52"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "21.65 12.5 0 25 -21.65 12.5 -21.65 -12.5 0 -25 21.65 -12.5 21.65 12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "4.31 22.51 5.21 21.99 5.21 3.01 21.65 -6.48 21.65 -7.52 4.31 2.49 4.31 22.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "7.34 20.76 8.24 20.24 8.24 4.76 21.65 -2.98 21.65 -4.02 7.34 4.24 7.34 20.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "10.38 19.01 11.28 18.49 11.28 6.51 21.65 .52 21.65 -.52 10.38 5.99 10.38 19.01"
  }))))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 346.41,
    height: 225
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/bg3.8dbc3e35f65c9bdd39d95f82344f015b.svg";
export { ForwardRef as ReactComponent };